import { MakerCheckerInputs } from '@/dialogs/ticketTypes/makerChecker'
import { BankReportInputs } from '@/dialogs/ticketTypes/bankReport'
import { CompanyReportInputs } from '@/dialogs/ticketTypes/companyReport'
import { MergedCompaniesInputs } from '@/dialogs/ticketTypes/mergedCompanies'

export function createInputs (ticketType) {
  switch (ticketType) {
    case 'CreatingIndividual':
    case 'ManageIndividuals':
    case 'ManageBanks':
    case 'ManageCompanies':
    case 'ManageBlacklists':
    case 'ManageFines':
    case 'ManageRtgsreports':
    case 'ManageRtgsReports':
      return MakerCheckerInputs
    case 'ManageMergedCompanies':
      return MergedCompaniesInputs
    case 'Bs-FineImposition':
    case 'FinOps-AddressingBank':
    case 'FinOps-AdministrativePenalty':
    case 'FinOps-FineImposition':
      return BankReportInputs
    case 'Company-AdministrativePenalty':
      return CompanyReportInputs
  }
  return function () {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/dialogs/ticketTypes/index.js